import React from 'react';
import { useTranslation } from 'react-i18next';
import { toCurrency } from 'utilities/currency';
import { MarketButton } from '@market/react';
import { getDomain } from 'utilities/environment';
import makeStyles from '@mui/styles/makeStyles';
import { useFeatureFlags } from 'components/context/feature_flags';
import { isOrderFromOnboarding } from 'helpers/search_parameter_helpers';

const CustomArrowLeftIcon = () => (
  <svg
    slot="icon"
    width="15"
    height="16"
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.292894 7.26947C-0.0976308 7.65999 -0.0976307 8.29316 0.292894 8.68368L7.29289 15.6837L8.70711 14.2695L3.41421 8.97658L15 8.97658L15 6.97658L3.41421 6.97658L8.70711 1.68368L7.29289 0.26947L0.292894 7.26947Z"
      fill="black"
      fillOpacity="0.9"
    />
  </svg>
);

const useStyles = (isMpo) =>
  makeStyles((theme) => ({
    textContainer: {
      padding: theme.spacing(2),
      [theme.breakpoints.down('md')]: {
        alignItems: 'center',
        ...(isMpo ? { marginRight: '46px' } : {}),
      },
    },
    header: {
      fontSize: 'var(--core-type-display-10-size)',
      letterSpacing: '-0.4px',
      fontWeight: 'var(--core-type-bold-weight)',
      [theme.breakpoints.down('md')]: {
        fontSize: 'var(--core-type-heading-30-size)',
      },
    },
  }))();

const CartHeader = (props) => {
  const { t } = useTranslation();

  const { itemsCount = 0, total = 0, currency = 'USD' } = props;
  const { mpoPhase3Enabled } = useFeatureFlags();
  const isMpo = mpoPhase3Enabled && isOrderFromOnboarding();

  const classes = useStyles(isMpo);

  const detail = () => {
    let cost;
    switch (itemsCount) {
      case 0: {
        return null;
      }
      case 1: {
        cost = toCurrency(total, currency);
        return t('cart.label.costDetailSingle', { cost });
      }
      default: {
        cost = toCurrency(total, currency);
        return t('cart.label.costDetailMultiple', { itemsCount, cost });
      }
    }
  };

  return (
    <div
      style={{
        display: 'flex',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {isMpo && (
          <MarketButton size="small" href={`http://${getDomain()}/dashboard/`}>
            <CustomArrowLeftIcon />
          </MarketButton>
        )}
      </div>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
        }}
        className={classes.textContainer}
      >
        <span className={classes.header}>{t('cart.label.header')}</span>
        <p>{detail()}</p>
      </div>
    </div>
  );
};

export default CartHeader;
